import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { configuration } from 'src/environments/environment';
import { IProcedureCodes ,IprocedureCode, Icategorycode, ISnomed} from 'src/app/models/IProcedureCodes';
import { IProcedureCategory,IProcedureRegion } from 'src/app/models/IProcedures';
import { IOrdersLoinc } from 'src/app/models/ICptOrdersComponent';

@Injectable({
  providedIn: 'root'
})

@Injectable({
  providedIn: 'root'
})
export class ProcedureCodesService {
  temppage: number = 0;    
  pageField = [];
  exactPageList: any; 

  constructor(private http: HttpClient) { }

  // getActiveCptCodes(): Observable<IProcedureCodes[]> {
  //   return this.http.get<IProcedureCodes[]>
  //     (`${configuration.apiUrl + 'Master/ActiveCodes'}?facilityId=${sessionStorage.getItem("FacilityId")}`);
  // }
  getActiveCptCodes(pageNo: number,pageSize:number,searchTerm:string): Observable<IProcedureCodes[]> {
    // return this.http.get<IProcedureCodes[]>
    //   (`${configuration.apiUrl + 'Master/ActiveCodes'}?facilityId=${sessionStorage.getItem("FacilityId")}&&pageNo=${pageNo}&&pageSize=${pageSize}&&searchTerm=${searchTerm}`);
    const postedData = {
      facilityId: sessionStorage.getItem("FacilityId"),     
      pageNo:pageNo,
      pageSize:pageSize,
      searchTerm:searchTerm
    }
    return this.http.post<IProcedureCodes[]>(`${configuration.apiUrl + 'Master/GetActiveCodes'}`, postedData,{
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getActiveCptCategories(cptId: number): Observable<Icategorycode[]> {
    return this.http.get<Icategorycode[]>
      (`${configuration.apiUrl + 'Master/getCPTCategorydetails'}?cptId=${cptId}`);
  }

  saveActiveCptCodeInfo(mastercpt1: IProcedureCodes[]): Observable<string> {
    const  mastercpt=Object.assign({},mastercpt1)
    return this.http.post<string>(`${configuration.apiUrl + 'Master/ActiveCodes'}?facilityId=${sessionStorage.getItem("FacilityId")}`, mastercpt, {
      // headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  deleteActiveCodes(cptId: string): Observable<string> {    
    return this.http.post<string>(`${configuration.apiUrl + 'Master/ActiveCodes'}?masterCptId=${cptId}&&facilityId=${sessionStorage.getItem("FacilityId")}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  getProcedureBySearch(cptCode:string): Observable<IProcedureCodes[]> {
    return this.http.get<IProcedureCodes[]>
      (`${configuration.apiUrl + 'Master/SearchCPTCodes'}?cptCode=${cptCode}&&facilityId=${sessionStorage.getItem("FacilityId")}`);
  }
  getCptCodesdetails(cptId: number): Observable<IprocedureCode[]> {
    return this.http.get<IprocedureCode[]>
      (`${configuration.apiUrl + 'Master/getCPTCodedetails'}?cptId=${cptId}`);
  }
  
  updateCPTCodes(CPTInfo: IProcedureCodes):Observable<string> {
    return this.http.put<string>(`${configuration.apiUrl + 'Master/UpdateActiveCode'}`, CPTInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getProcedureCategory(): Observable<IProcedureCategory[]> {
    return this.http.get<IProcedureCategory[]>(
      `${configuration.clinicapiUrl + 'Encounter/ProcedureCategory'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  getAnatomicalregions(): Observable<IProcedureRegion[]> {
    return this.http.get<IProcedureRegion[]>(
      `${configuration.clinicapiUrl + 'Encounter/Procedureregion'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }


  updateIsActiveStatusCPTCodes(masterCptId:number):Observable<string> {
    return this.http.put<string>(`${configuration.apiUrl + 'Master/UpdateIsActiveStatusActiveCodes'}?masterCptId=${masterCptId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  saveCPTCodedetails(mastercpt: IprocedureCode): Observable<string> {
    const postedData={
      inputdata:JSON.stringify(mastercpt)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Master/setCptCodedetails'}?facilityId=${sessionStorage.getItem("FacilityId")}`, postedData, {
      // headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  saveCPTRegion(anatomicarea: string): Observable<any> {
    return this.http.post<any>(`${configuration.clinicapiUrl + 'Encounter/AddCPTRegion'}?anatomicarea=${anatomicarea}&&facility=${sessionStorage.getItem("FacilityId")}`, {
    });
  }
  saveCPTcategory(categoryName: string, IsActive : boolean): Observable<any> {
    return this.http.post<any>(`${configuration.clinicapiUrl + 'Encounter/AddCPTcategorys'}?categoryName=${categoryName}&&IsActive=${IsActive}&&facilityId=${sessionStorage.getItem("FacilityId")}`, {
    });
  }

  updateManageCptCodedetails(cptInfo: IprocedureCode): Observable<string> {
    const  postedcptInfo=Object.assign({},cptInfo)
    return this.http.put<string>(`${configuration.apiUrl + 'Master/updateCptCodedetails'}?facilityId=${sessionStorage.getItem("FacilityId")}`, postedcptInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  updateManageCptCodeCategorydetails(cptcategoryInfo: IprocedureCode): Observable<string> {
    const posteddata={
      inputdata:JSON.stringify(cptcategoryInfo)
    }
    return this.http.put<string>(`${configuration.apiUrl + 'Master/updateCptCategorydetails'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  deleteCptcodedetails(cptId: number, masterCPTAliasId : number): Observable<string> {    
    return this.http.post<string>(`${configuration.apiUrl + 'Master/deletecptCodedetails'}?cptId=${cptId}&&masterCPTAliasId=${masterCPTAliasId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  getActiveProcedures(patId: any): Observable<IprocedureCode[]> {
    return this.http.get<IprocedureCode[]>
      (`${configuration.apiUrl + 'Master/ActiveProcedures'}?patId=${patId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  deleteAllCptdetails(cptId: number): Observable<string> {    
    return this.http.post<string>(`${configuration.apiUrl + 'Master/deleteAllcptCodedetails'}?cptId=${cptId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  pageOnLoad() {
    if (this.temppage == 0) {
      this.pageField = [];
      for (var a = 0; a < this.exactPageList; a++) {
        this.pageField[a] = this.temppage + 1;
        this.temppage = this.temppage + 1;
      }
    }
  }
  getCountCPT(searchTerm:string): Observable<any> {
    return this.http.get<any>(`${configuration.apiUrl + 'Master/GetCountCPTs'}?facility=${sessionStorage.getItem("FacilityId")}&&searchTerm=${searchTerm}`);
  }

  getCountCPTBYICD(ICDCode:string): Observable<any> {
    return this.http.get<any>(`${configuration.apiUrl + 'Master/GetCountCPTsByICD'}?facility=${sessionStorage.getItem("FacilityId")}&&ICDCode=${ICDCode}`);
  }

  getSnomedBySearch(snomedCode:string): Observable<ISnomed[]> {
    return this.http.get<ISnomed[]>
      (`${configuration.apiUrl + 'Master/SearchSnomedCodes'}?snomedCode=${snomedCode}&&facilityId=${sessionStorage.getItem("FacilityId")}`);
  }

  getLoincCodeBySearch(searchText:string): Observable<IOrdersLoinc[]> {
    return this.http.get<IOrdersLoinc[]>
      (`${configuration.apiUrl + 'Master/SearchLoincCodes'}?searchText=${searchText}`);
  }
}
